// extracted by mini-css-extract-plugin
export var border = "_28-7";
export var brand = "_28-s";
export var button = "_28-k";
export var center = "_28-9";
export var centered = "_28-5";
export var closeButton = "_28-b";
export var disabledWrapper = "_28-l";
export var error = "_28-o";
export var extraLarge = "_28-4";
export var extraSmall = "_28-1";
export var fill = "_28-h";
export var footer = "_28-g";
export var footerAction = "_28-i";
export var footerButtons = "_28-j";
export var header = "_28-6";
export var headerWithClose = "_28-c";
export var icon = "_28-n";
export var info = "_28-r";
export var inline = "_28-8";
export var large = "_28-3";
export var main = "_28-d";
export var modal = "_28-0";
export var neutral = "_28-t";
export var noPadding = "_28-f";
export var none = "_28-u";
export var scrollable = "_28-e";
export var small = "_28-2";
export var success = "_28-q";
export var tight = "_28-m";
export var titleIcon = "_28-a";
export var warn = "_28-p";